// extracted by mini-css-extract-plugin
export default {"selectListContainer":"UpdateActivityTeamsForm_selectListContainer__gt-mn","invitedTeamsCount":"UpdateActivityTeamsForm_invitedTeamsCount__loe8z"};